import { render } from "./BasePillField.vue?vue&type=template&id=035ae1a8"
import script from "./BasePillField.vue?vue&type=script&lang=js"
export * from "./BasePillField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__